/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MediapipeDemoRouteImport } from './routes/mediapipe-demo'
import { Route as IndexRouteImport } from './routes/index'

const MediapipeDemoRoute = MediapipeDemoRouteImport.update({
  id: '/mediapipe-demo',
  path: '/mediapipe-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/mediapipe-demo': typeof MediapipeDemoRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/mediapipe-demo': typeof MediapipeDemoRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/mediapipe-demo': typeof MediapipeDemoRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/mediapipe-demo'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/mediapipe-demo'
  id: '__root__' | '/' | '/mediapipe-demo'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MediapipeDemoRoute: typeof MediapipeDemoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/mediapipe-demo': {
      id: '/mediapipe-demo'
      path: '/mediapipe-demo'
      fullPath: '/mediapipe-demo'
      preLoaderRoute: typeof MediapipeDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MediapipeDemoRoute: MediapipeDemoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
